import { NavController } from '@ionic/angular';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';

@Component({
  selector: 'show-modal',
  templateUrl: 'show-modal.html',
  styleUrls:['./show-modal.scss']
})
export class CountdownComponent {

  counter = 10;
  interval;
  countdownBg = CountdownBg.FOREST;
  noGpsSignal = false;
  lowGpsSignal = true;
  highGpsSignal = false;
  showCountDown;
  routerState:any;

  constructor(
    public navController: NavController,
    public router:Router,
    public translate: TranslateService
  ) {
    const nav = this.router.getCurrentNavigation();
    this.routerState = nav?.extras?.state || {};
    this.countdownBg = this.routerState['countdownBg'];
    this.checkGpsSignal();
    this.onCloseTimer();
  }

  onCloseTimer() {
    this.interval = setInterval(() => {
      this.counter = this.counter - 1;
      if (this.counter === 0) {
        clearInterval(this.interval)
        this.navController.pop();
      }
    }, 1000)
  }

  checkGpsSignal() {//bohdan
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.clearSignals();
        if (position.coords.accuracy < 50) {
          this.lowGpsSignal = true;
        } else if (position.coords.accuracy >= 50) {
          this.highGpsSignal = true;
        }
      });
    }
    else {
      this.clearSignals();
      this.noGpsSignal = true;
    }
  }

  clearSignals() {
    this.noGpsSignal = this.lowGpsSignal = this.highGpsSignal = false;
  }

  onCloseModal() {
    this.navController.pop();
    clearInterval(this.interval)
  }
}


export enum CountdownBg {
  APPLAUSE,
  FOREST
}